import React from 'react'
import Loader from '../Loader/Loader';
import DocumentsUp from '../DocumentsUp/DocumentsUp';

const Suplier = ({  load, setLoad,currentSupplier }) => {
  if (load) {
    return <Loader/>;
  }
  return (
    <>
      <DocumentsUp setLoad={setLoad} load={load} vname={currentSupplier.vendorName}/>
    </>
  )
}

export default Suplier